import { createContext, useContext, useState } from 'react';
const StateContext = createContext();

const initialState = {
	chat: false,
	cart: false,
	userProfile: false,
	notifications: false,
};

export const ContextProvider = ({ children }) => {
	const [screenSize, setScreenSize] = useState(undefined);
	const [currentColor, setCurrentColor] = useState('#00597e');
	const [currentDept, setCurrentDept] = useState('');
	const [currentMode, setCurrentMode] = useState('Dark');
	const [themeSettings, setThemeSettings] = useState(false);
	const [activeMenu, setActiveMenu] = useState(true);
	const [isClicked, setIsClicked] = useState(initialState);
	const [currentUser, setCurrentUser] = useState('');
	const [categories, setCategories] = useState({
		parents: [],
		children: [],
	});

	const setColor = (color) => {
		setCurrentColor(color);
		localStorage.setItem('colorMode', color);
	};

	const setMode = (e) => {
		setCurrentMode(e.target.value);
		localStorage.setItem('themeMode', e.target.value);
	};

	const setUser = (user) => {
		setCurrentUser(user);
		localStorage.setItem('user', JSON.stringify(user));
	};

	const setDept = (dept) => {
		setCurrentDept(dept);
		localStorage.setItem('dept', JSON.stringify(dept));
	};

	const getCategory = (id) => {
		return categories.children.find((category) => category.id === id);
	}

	const setCats = (cats) => {
		setCategories({
			parents: cats.filter(cat => !cat.parentCategoryId),
			children: cats.filter(cat => cat.parentCategoryId),
		})
	}

	const handleClick = (clicked) =>
		setIsClicked({ ...initialState, [clicked]: true });

	return (
		<StateContext.Provider
			value={{
				screenSize,
				setScreenSize,
				currentColor,
				setCurrentColor,
				currentMode,
				setCurrentMode,
				themeSettings,
				setThemeSettings,
				activeMenu,
				setActiveMenu,
				isClicked,
				setIsClicked,
				currentUser,
				setCurrentUser,
				currentDept,
				setCurrentDept,
				setDept,
				setColor,
				setMode,
				setUser,
				handleClick,
				initialState,
				categories,
				setCats,
				getCategory,
			}}
		>
			{children}
		</StateContext.Provider>
	);
};

export const useStateContext = () => useContext(StateContext);
